import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import { INCIDENCES_LIST_KEY } from 'modules/sales/incidence/constants';
import { INCIDENCE_SOLUTION_TYPE } from 'modules/sales/incidence/constants/incidence-solution.enum';
import { IncidenceService } from 'modules/sales/incidence/services';
import { SOLUTION_STATUS } from './solution-status.enum';
import { sanitizeTextFilter } from 'utils/search.utils';
import { TermFilter } from '@dofleini/query-builder';

export const solutionTypeFilter: Filter = {
  filter: 'incidenceResolution:fields.type',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'solution-type',
  field: 'type',
  options: Object.keys(INCIDENCE_SOLUTION_TYPE).map((key) => ({
    value: key,
    translate: true,
    label: `breadcrumb:${key}`,
  })),
};

export const orderFilter = {
  filter: 'incidenceResolution:fields.orderCode',
  field: 'orderReference.code',
  type: FilterType.TEXT,
  translate: true,
  key: 'order',
  transform: (value: any) => {
    const queryText = sanitizeTextFilter(value);
    if (!queryText) return undefined;
    return new TermFilter({
      field: 'orderReference.code',
      value: {
        $regex: queryText,
        $options: 'i',
      },
    });
  },
};

export const incidenceFilter = {
  filter: 'incidenceResolution:fields.incidence',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'incidence',
  labelKey: 'code',
  field: 'incidentReference._id',
  fetchFunc: IncidenceService.search,
  queryKey: INCIDENCES_LIST_KEY,
};

export const refundFilter = {
  filter: 'incidenceResolution:fields.refund',
  translate: true,
  type: FilterType.NUMBER,
  key: 'refund',
  field: 'refund.total',
};

export const expenseFilter = {
  filter: 'incidenceResolution:fields.bills',
  translate: true,
  type: FilterType.NUMBER,
  key: 'expense',
  field: 'chargeToResponsible.total',
};

export const chargeToClientFilter = {
  filter: 'incidence:summary.chargeToClient',
  translate: true,
  type: FilterType.NUMBER,
  key: 'chargeToClient',
  field: 'chargeToClient.total',
};

export const solutionStatusFilter: Filter = {
  filter: 'provider:fields:state',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'status',
  field: 'refund.status',
  options: Object.keys(SOLUTION_STATUS).map((key) => ({
    value: key,
    translate: true,
    label: `incidenceResolution:status.${key}`,
  })),
};

export const incidenceResolutionFilters = [
  solutionTypeFilter,
  orderFilter,
  incidenceFilter,
  chargeToClientFilter,
  refundFilter,
  expenseFilter,
  solutionStatusFilter,
  createdATFilter,
];
